import { CompanyMediaJSON, CompanyProfile } from '../types';

export default class CompanyMediaSerializers {
  static toJSON(company: Pick<CompanyProfile, 'companyMediaFiles'>) {
    return {
      company_media_files: {
        images: company.companyMediaFiles.images?.map((image) => ({
          resource_id: image.resourceId,
          source_url: image.sourceUrl,
          created_at: image.createdAt,
        })),
        videos: company.companyMediaFiles.videos?.map((video) => ({
          recource_id: video.resourceId,
          source_url: video.sourceUrl,
          created_at: video.createdAt,
        })),
      },
    };
  }

  static toObject(payload: CompanyMediaJSON): {
    companyMediaFiles: CompanyProfile['companyMediaFiles'];
  } {
    return {
      companyMediaFiles: {
        images: payload.company_media_files.images.map((image) => ({
          resourceId: image.resource_id,
          sourceUrl: image.source_url,
          createdAt: image.created_at,
        })),
        videos: payload?.company_media_files.videos.map((video) => ({
          resourceId: video.resource_id,
          sourceUrl: video.source_url,
          createdAt: video.created_at,
        })),
      },
    };
  }
}
